<template>
    <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @play="playVideos($event)"
        @ended="onPlayerEnded($event)"
        @pause="onPlayerPause($event)"
        @timeupdate="onPlayerTimeupdate($event)"
        @loadeddata="onPlayerLoadeddata($event)"
        @waiting="onPlayerWaiting($event)"
    ></video-player>
</template>
<style>
.video-player {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 12;
}
.video-js .vjs-big-play-button {
    border: none !important;
    width: 2em !important;
    border-radius: 100% !important;
    margin-left: -0.75em !important;
    
}
.ant-back-top, .change-music{
    z-index: 12 !important;
}
</style>
<script>
export default {
    props: ['videoUrl', 'backgroundUrl','index'],
    data() {
        return {
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: '', //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: this.videoUrl,
                    },
                ],
                poster: this.backgroundUrl,
                //poster: this.videoBackgroundImg,//你的封面地址
                // width: document.documentElement.clientWidth, //播放器宽度
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true, //全屏按钮
                },
            },
        };
    },
    methods: {
        pauseMusic() {
           
            // let audios = document.getElementsByTagName('audio');
            // // 视频播放时停止其他的音频播放
            // [].forEach.call(audios, function(i, index) {
            //     i.pause();
            // }); 
            let music = document.getElementById('musicPlayBox')
            let backgroundMusic = music.getElementsByTagName('audio');
            //清除背景音乐
            for(let i = 0; i < backgroundMusic.length; i++){
                backgroundMusic[i].pause()
            }
            //改变所有的麦克风状态
            //this.$emit('banAllMicroPhone');
        },
        playVideos(event) {
            this.pauseMusic()
            let that = this;
            let videos = document.getElementsByTagName('video');

            if(this.index == 13){
                // this.z_index = false
                 document.getElementsByClassName('searchPos11')[0].style.zIndex = 0
            }
            // 暂停函数
            function pauseAll() {
                let self = this;
                [].forEach.call(videos, function(i, curIndex) {
                    // 将videos中其他的video全部暂停
                    if (i != self) {
                        i.pause();
                    } else {
                        i.play();
                    }
                });
            }
            // 给play事件绑定暂停函数
            [].forEach.call(videos, function(i, curIndex) {
                i.addEventListener('play', pauseAll.bind(i));
            });
        },
        onPlayerEnded(event) {
            this.$emit('playBackgroundMusic'); 
        },
        onPlayerPause(event) {
            this.$emit('playBackgroundMusic');
            document.getElementsByClassName('searchPos11')[0].style.zIndex = 111 
        },
        onPlayerTimeupdate(event) {
            this.pauseMusic();
        },
        onPlayerLoadeddata(event) {
            this.pauseMusic();
        }
    },
};
</script>
